/*
 * @Author: yaoyuting
 * @Date: 2021-04-23 17:17:07
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-27 18:57:01
 * @Descripttion:
 */
import {
  get, gets, post, posts,
} from './server.js';
export const base = 'http://www.uqc.net.cn/invest/contact/' 
export const GetcommitApply = p => post(base +`commit`,p);

